export default __webpack_public_path__ + "static/media/backColor.86159136.svg";